<template>
    <CModal
      :color="color"
      :show.sync="showModal"
      size="lg"
      class="basic-modal-color"
    >   
    <template #header>
      <CRow style="width: 100%; height: 35px;">
        <CCol md="9">
          <h5 class="modal-title">{{title}}</h5>
        </CCol>
        <CCol md="3">
          
        </CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>            
    </template>
      <CRow>      
        <CCol md="12">
          <CInput
            label="Mensaje para los Invitados:"
            :lazy="false"
            :value.sync="message"
            name="name"
            id="name"
            placeholder=""
            autocomplete="given-name"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
          />
        </CCol>
        <CCol md="12">
          <CRow class="mb-3">
            <CCol md="4" sm="12" class="d-flex align-items-center mb-2 mb-md-0">
              <CButton class="crema" size="sm" :disabled="isSearching" @click="selectAll()">Seleccionar Todos</CButton>
            </CCol>
            <CCol md="8" sm="12" class="d-flex align-items-center">
              <input
                v-model="searchTerm"
                type="text"
                class="form-control"
                placeholder="Buscar invitado..."
              />
            </CCol>
          </CRow>
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="filteredGuests"
            :fields="fields"
            :dark="dark"
            :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'Sin Invitados' }"
          >         
            <template #position="{item}">
              <td class="text-center w80">
                <input
                  type="checkbox"
                  v-model="idsGuests"
                  @change="checkGuests(item)"
                  :value="item.id"
                  :id="'check-'+item.id"
                  :disabled="isInCooldown(item)"
                >
              </td>
            </template>
            <template #name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.name}}</b></td></template>
            <template #last_name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.last_name}}</b></td></template>
            <template #nickname="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.nickname}}</td></template>
            <template #phone="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                {{item.phone}}
                <div v-if="Number(item.is_in_cooldown) === 1 && item.whatsapp_cooldown_until" style="font-size: 11px;">
                  <CBadge color="warning">Cooldown</CBadge>
                  hasta {{ item.whatsapp_cooldown_until | datetime }}
                </div>
              </td>
            </template>
            <template #email="{item}">
              <td class="text-center w200" style="font-size: 12px;">
                <template v-if="item.email != ''">
                  {{item.email}}
                </template>
                <template v-else>
                  -
                </template>                  
              </td>
            </template>
            <template #tickets="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.tickets}}</td></template>
            <template #table="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                <template v-if="item.table != ''">
                  {{item.table}}
                </template>
                <template v-else>
                  -
                </template>                
              </td>
            </template>
            <template #confirm_date="{item}">
              <td class="text-center w100">
                <template v-if="item.is_confirm != ''">
                  {{item.confirm_date | date}}                  
                </template>                
              </td>
            </template>       
            <template #confirm_method="{item}">
              <td class="text-center w100" style="font-size: 16px;">
                <template v-if="item.confirm_method == 'admin'">
                  Administrador
                </template>
                <template v-else-if="item.confirm_method == 'whats'">
                  Whatsapp
                </template>
                <template v-else-if="item.confirm_method == 'email'">
                  Correo Electronico
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </template>                 
            <template #is_confirm="{item}">
              <td class="text-center w100" style="font-size: 16px;">
                <template v-if="item.is_confirm == 0">
                  <CBadge color="warning">Pendiente</CBadge>
                </template>
                <template v-else-if="item.is_confirm == 2">
                  <CBadge color="danger">No</CBadge>
                </template>
                <template v-else>
                  <CBadge color="success">Si</CBadge>
                </template>          
              </td>
            </template>
            <template #actions="{item}">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">                
              </td>
            </template>
          </CDataTable>        
        </CCol>              
      </CRow>      
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="sendMessage" :color="color">Enviar Mensaje</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'SendMasiveMessageModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°' ,_style:"font-size: 12px;"},
          {key: 'name', label: 'Nombre',_style:"font-size: 12px;"},
          {key: 'last_name', label: 'Apellido',_style:"font-size: 12px;"},
          {key: 'nickname', label: 'Apodo',_style:"font-size: 12px;"},
          {key: 'phone', label: 'Whatsapp',_style:"font-size: 12px;"},
          {key: 'email', label: 'Email',_style:"font-size: 12px;"},
          {key: 'tickets', label: 'Invitados',_style:"font-size: 12px;"},
          {key: 'table', label: 'Mesa',_style:"font-size: 12px;"},
          {key: 'is_confirm', label: 'Confirmación',_style:"font-size: 12px;"},
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Enviar Mensaje a Invitados Confirmados",
      color: "info",
      submitted: false,      
      guests: [],      
      idsGuests:[],
      statusCheckAll: false,
      event: false,
      message: "",
      searchTerm: ""
    }
  },
  mounted: async function() {    
    
  },
  computed: {
    isSearching () {
      return this.searchTerm.trim().length > 0;
    },
    filteredGuests () {
      if (!this.isSearching) {
        return this.guests;
      }

      const term = this.searchTerm.trim().toLowerCase();

      return this.guests.filter(guest => {
        const searchableValues = [
          guest.name,
          guest.last_name,
          guest.nickname,
          guest.phone,
          guest.email,
          guest.table,
          guest.tickets,
        ]
          .map(value => (value === null || value === undefined ? '' : String(value).toLowerCase()))
          .join(' ');

        return searchableValues.includes(term);
      });
    },
  },
  methods: {
    isInCooldown (guest) {
      if (!guest) return false;
      return Number(guest.is_in_cooldown) === 1 && !!guest.whatsapp_cooldown_until;
    },
    selectedGuestsWithoutCooldown () {
      const selected = this.idsGuests || [];
      return selected.filter(id => {
        const guest = this.guests.find(item => item.id === id);
        return guest && !this.isInCooldown(guest);
      });
    },
    async showSendModal (event_id, event) {
      this.event = event;
      this.message = "";
      this.searchTerm = "";

      this.loading();
        this.showModal = true;
        this.color = "info";
        this.title = 'Enviar Mensaje a Invitados Confirmados';
        this.isEdit = false;
        this.submitted = false;

        this.guests = [];
        this.idsGuests = [];
        this.statusCheckAll = false;

        let filters = {
          event_id: event_id,
          is_confirm: 1,
        };
      
        let response = await ws.get(filters);
        if(response.type == "success"){
          this.guests = response.data;

          this.guests.forEach(function callback(guest) {
              guest.checkbox = false;
          });
        }
      this.loaded();

    },
    async sendMessage () {
      this.loading();

      let guests = this.selectedGuestsWithoutCooldown();
      this.idsGuests = guests;

      if(this.message == ''){
        this.showToast("error", "Debes seleccionar ingresar un mensaje para enviarlo a los invitados.");
      }
      else{
        if(guests.length > 0){
          let response = await ws.sendMasiveMessage({data: guests, message: this.message});

          this.closeModal();

          if(response.type == "success"){
            this.showToast("success", response.message || "El mensaje para los invitados han sido enviado correctamente.");
          }
          else{
            this.showToast("error", response.message);
          }
        }
        else{
          this.showToast("error", "Debes seleccionar al menos un invitado para enviar el mensaje.");
        }
      }

      this.loaded();          
    },
    checkGuests: function(element){
      if (!this.idsGuests.includes(element.id)) {
        this.statusCheckAll = false;
      }
    },
    selectAll () {
      if (this.isSearching) {
        return;
      }

      if(!this.idsGuests.length > 0){
        this.statusCheckAll = false;  
      }
      this.idsGuests = [];            
      this.statusCheckAll = !this.statusCheckAll
      if(this.statusCheckAll){
        this.guests.forEach(element => {
          if (this.isInCooldown(element)) {
            return;
          }
          this.idsGuests.push(element.id) ;
        });
      }
    },
    closeModal () {
      this.showModal = false;
      this.searchTerm = "";

      this.guests.forEach(function callback(guest) {
          guest.checkbox = false;
      });

      this.submitted = false
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
.crema{
  background-color: #F4F0E5;
  color: black;
}
</style>